import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Zap, Star } from "lucide-react";
import { api, gbp, fmtDay, fileUrl } from "../lib/api";

function DealCard({ a }) {
  const img = a.images?.[0];
  return (
    <Link to={`/adverts/${a.slug}`} className="card-hover overflow-hidden flex flex-col" data-testid={`lastmin-card-${a.slug}`}>
      <div className="aspect-[4/3] bg-[#FAF7EE] relative overflow-hidden">
        {img ? <img src={fileUrl(img)} alt={a.title} className="w-full h-full object-cover" /> : <div className="w-full h-full grid place-items-center text-slate-300"><Zap size={36} /></div>}
        <span className="absolute top-3 left-3 rounded-full bg-violet-600 text-white text-xs font-bold px-2.5 py-1" data-testid="lastmin-badge">−{a.deal.percent}%</span>
      </div>
      <div className="p-4 flex flex-col flex-1">
        <h3 className="font-bold text-slate-900 line-clamp-2">{a.title}</h3>
        <p className="text-xs text-slate-500 mt-1 flex items-center gap-1">{a.provider.business_name}{a.provider.rating ? <><Star size={11} className="text-amber-500 fill-amber-500" />{a.provider.rating}</> : null}</p>
        <p className="text-xs text-violet-700 font-semibold mt-2">Free: {a.deal.dates.map(fmtDay).join(" or ")}</p>
        <div className="mt-auto pt-3 flex items-baseline gap-2"><b className="text-lg text-slate-900">{gbp(a.deal.price)}</b><s className="text-sm text-slate-400">{gbp(a.price)}</s></div>
      </div>
    </Link>
  );
}

export default function LastMinuteDeals() {
  const [ads, setAds] = useState([]);
  useEffect(() => { api.get("/adverts/last-minute").then((r) => setAds(r.data)).catch(() => {}); }, []);
  if (!ads.length) return null;
  return (
    <section className="bg-violet-50/60" data-testid="home-lastmin">
      <div className="container-x py-14">
        <div className="mb-6"><span className="eyebrow !text-violet-700 flex items-center gap-1"><Zap size={14} />Last-minute deals</span><h2 className="h2 mt-2">Free slots in the next 48 hours, at a discount</h2></div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 stagger">{ads.slice(0, 4).map((a) => <DealCard key={a.id} a={a} />)}</div>
      </div>
    </section>
  );
}
